import type { BaseTeam } from "@redotech/account-common/base-team";
import { GetUser } from "@redotech/account-common/user";
import {
  type OMSUser,
  OMSUserSchema,
  unassignedUser,
} from "@redotech/redo-model/fulfillments/oms-user";

export const getUserToOmsUser = (user: GetUser): OMSUser => {
  return OMSUserSchema.parse({
    roles: null,
    _id: user._id.toString(),
    email: user.email,
    createdAt: user.createdAt,
    firstName: user.firstName,
    lastName: user.lastName,
    name: user.name,
    updatedAt: user.updatedAt,
    team: user.team,
  });
};

export const getTeamOMSUsers = (team: BaseTeam): OMSUser[] => {
  const users = (team?.users || []).reduce((acc: OMSUser[], user) => {
    try {
      if (user?.user && typeof user.user !== "string") {
        acc.push(getUserToOmsUser(user.user));
      }
      return acc;
    } catch (error) {
      return acc;
    }
  }, []);

  return [...users, unassignedUser];
};
